import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar';
import './index.scss';

const Layout = () => {
    const location = useLocation();
    const isWorkReport = location.pathname.startsWith('/work/report');

    return (
        <div className="App">
            {!isWorkReport && <Sidebar />} 
            <div className='page'>
                {!isWorkReport && <span className='tags top-tags'>&lt;body&gt;</span>}

                <Outlet />

                {!isWorkReport && <span className='tags bottom-tags'> 
                &lt;/body&gt;
                <br />
                <span className='bottom-tag-html'>&lt;/html&gt;</span>
                </span>}
            </div>
        </div>   
    )
}

export default Layout;